import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { ModalsSlice } from 'featureSliced/shared/store/reducers/ModalsReducer'
import { IModal } from 'featureSliced/shared/store/reducers/ModalsReducer/types'

export type OpenModalFuncType = (params: IModal) => void

export const useOpenModal = (): OpenModalFuncType => {
  const { modals } = useMySelector((state) => state)
  const dispatch = useMyDispatch()

  const { openModal: openModalAction, closeModal } = ModalsSlice.actions

  const handleClose = (id: string, onClose?: (id: string) => void) => {
    if (onClose) {
      onClose(id)
    }
    dispatch(closeModal(id))
  }

  const openModal = ({
    id,
    components,
    title = '',
    onClose,
    shouldHideCross,
    startIndex,
    dialogWidth,
  }: IModal) => {
    dispatch(
      openModalAction({
        components,
        id,
        title,
        shouldHideCross,
        onClose: () => handleClose(id, onClose),
        startIndex,
        dialogWidth,
      })
    )
    return modals?.length
  }
  return openModal
}
